module.exports = __webpack_public_path__ + "static/assets/e97bd6325f30435c66d19f918b5502d7.svg";